import { MyLink } from '@ui-kit/Link';
import IconMiniLogo from './mini-logo-icon.svg';

import styles from './MiniLogo.module.scss';

export const MiniLogo = (): JSX.Element => {
  return (
    <MyLink className={styles.Logo} href="/">
      <IconMiniLogo />
    </MyLink>
  );
};
